import * as ko from 'knockout'
import {FilterDto, FilterGroupDto} from '../../api/generated';
import ViewModelFunction = KnockoutComponentTypes.ViewModelFunction;


interface ViewModelParams {
    filter: FilterDto;
    groups: Array<FilterGroupDto>
    selectedFilters: Map<number, KnockoutObservableArray<number>>;
}

class ViewModel {

    public filter: FilterDto;
    public group: FilterGroupDto;
    public selectedFilterIds: KnockoutObservableArray<number>;
    public iconCssClass: KnockoutComputed<string>;

    constructor(private params:ViewModelParams) {
        this.filter = params.filter;
        this.group = params.groups[0]; // always the first group
        this.selectedFilterIds = params.selectedFilters.get(this.group.id);
        this.iconCssClass = ko.pureComputed(() =>
            this.filter.icon ? this.filter.icon.replace(/^(filter-icon-)/,"") : ""
        );
    }

    /**
     * Filter is selected?
     */
    public selected: KnockoutComputed<boolean> = ko.pureComputed(() => {
        return this.selectedFilterIds().indexOf(Number(this.filter.id)) > -1;
    });

    /**
     * Check whether the filter is is disabled and remove the filter from the selected filters.
     */
    public disabled: KnockoutComputed<boolean> = ko.pureComputed(() => {
        const disabled: boolean = !this.enabled();
        if(disabled && this.selectedFilterIds().indexOf(Number(this.filter.id)) > -1) {
            this.selectedFilterIds.splice(this.selectedFilterIds().indexOf(Number(this.filter.id)), 1);
        }
        return disabled;
    });

    /**
     * Check whether the filter is enabled.
     * Filter is enabled if the dependency matches the group id (root filter item)
     * or any of the selected filter ids (nested filter item).
     */
    public enabled: KnockoutComputed<boolean> = ko.pureComputed(() => {
        return this.filter.dependency.indexOf(this.group.id.toString()) > -1  // is a root filter item
         || this.selectedFilterIds().map(id => id.toString())
                .some(id => this.filter.dependency.indexOf(id) > -1) // parent filter item is selected
    });

    /**
     * Toggle the filter state.
     */
    public toggle = () => {
        let index:number = this.selectedFilterIds().indexOf(Number(this.filter.id));
        if(index > -1) {
            // deselect filter
            this.selectedFilterIds.splice(index, 1);
        } else if (this.enabled()) {
            // select filter
            this.selectedFilterIds.push(Number(this.filter.id));
        }
        console.debug('group: ', this.group.id, 'selected filter: ', this.selectedFilterIds());
    }
}


const component:KnockoutComponentTypes.Config<ViewModelFunction> = {
    viewModel: (params:ViewModelParams) => new ViewModel(params),
    template: <string>require('./filter.html')
};

export default component;

if (!ko.components.isRegistered('filter')) {
    ko.components.register('filter', component)
}